export enum DomainFamily {
  TRANSPORT = 't',
  CHAOS = 'c',
}

const domainFamilyKeys: string[] = Object.keys(DomainFamily).map(
  (key: string): string => DomainFamily[key],
);

// Eg:- capture 'c' in  https://experiments.stg-myteksi.com/c/experiments/scheduled
const extractDomainFamilyKeyRegx = new RegExp(
  // eslint-disable-next-line no-useless-escape
  `^\/(${domainFamilyKeys.join('|')})\/.+$`,
);

function getDomainFamily(): DomainFamily | undefined {
  const execArray = extractDomainFamilyKeyRegx.exec(window.location.pathname);
  if (execArray && execArray.length > 1) {
    const key = execArray[1];
    if (domainFamilyKeys.includes(key)) {
      return key as DomainFamily;
    }
  }
  return undefined;
}

export function getRolloutTabRoute() {
  return `/${getDomainFamily()}/variables/:variableName/rollout`;
}

export function getVariablesRoute() {
  return `/${getDomainFamily()}/variables/:variableName/:action`;
}

export function getRolloutTabVariableDetailsRoute() {
  return `/${getDomainFamily()}/variables/:variableName/rollout/:action`;
}
